module.exports = __webpack_public_path__ + "media/images/reviews/trust_pilot_with_count-38a4e711ad80870f0a8e5f42e82ff1e6.svg";